<template>
<v-container fluid>
<v-layout>
  <v-flex xs12>
   <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ request }} User Creation Request</span>
      </v-card-title>
      <v-card-text>
           <v-form ref="form" v-model="valid" lazy-validation>
             <v-row>
               <v-col cols="12" md="6">
              <v-text-field
               v-model="editedItem.firstName"
               label="First Name"
               required
               readonly
               >
               </v-text-field>
               </v-col>
               <v-col cols="12" md="6">
              <v-text-field
               v-model="editedItem.lastName"
               label="Last Name"
               required
               readonly
               >
               </v-text-field>
               </v-col>
              </v-row>
               <v-row>
               <v-col cols="12" md="6">
              <v-text-field
               v-model="editedItem.username"
               label="Username"
               required
               readonly
               >
              </v-text-field>
               </v-col>
                <v-col cols="12" md="6">
              <v-text-field
              v-model="editedItem.idNumber"
              label="idNumber"
              required
              readonly
              >
             </v-text-field>
               </v-col>
               </v-row>
               <v-row>
               <v-col cols="12" md="6">
             <v-text-field
             v-model="editedItem.phoneNumber"
             label="phoneNumber"
             required
             readonly
             >
            </v-text-field>
               </v-col>
               </v-row>
               <v-row>
               <v-col cols="12" md="6">
              <v-text-field
               v-model="editedItem.roleId"
               label="Role"
               required
               readonly
               >
              </v-text-field>
               </v-col>
               </v-row>
            </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click.native="close">Cancel</v-btn>
        <v-btn color="primary" @click.native="save">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
   <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
        <v-col cols="3">
        <v-text-field v-model="search" append-icon="search" label="Search"
          single-line hide-details color="primary"></v-text-field>
      </v-col>
    </v-card-title>
    <v-card-text>
    <v-data-table
        :headers="headers"
        :items="users"
        :search="search"
      >
      <template v-slot:[`item.created`]="{ item }">
        {{item.created | prettyDate }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
            color="primary"
            dark
            v-on="on"
            text
            icon
            class="actions"
          >
            <v-icon> more_horiz </v-icon>
          </v-btn>
          </template>
          <v-list>
            <v-list-item @click="approveItem(item)">
              <v-list-item-title> Approve </v-list-item-title>
            </v-list-item>
            <v-list-item @click="declineItem(item)">
              <v-list-item-title> Decline </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
     </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</v-flex>
</v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'

export default {
  name: 'approveexternalusers',
  data: function () {
    return {
      headers: [
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'Username', value: 'username' },
        { text: 'Phone', value: 'phoneNumber' },
        { text: 'ID No', value: 'idNumber' },
        { text: 'Role', value: 'roleId' },
        { text: 'Organization', value: 'organisationName' },
        { text: 'Maker Username', value: 'makerUsername' },
        { text: 'Request Type', value: 'requestType' },
        { text: 'Preffered User', value: 'preferredUser' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      users: [],
      loading: true,
      pagination: {},
      totalUsers: 0,
      dialog: false,
      editedIndex: -1,
      defaultItem: {
        id: '',
        firstName: '',
        lastName: '',
        username: '',
        roleId: '',
        organisationName: '',
        accountStatus: '',
        active: ''
      },
      editedItem: {
        id: '',
        firstName: '',
        lastName: '',
        username: '',
        roleId: '',
        organisationName: '',
        accountStatus: '',
        active: '',
        comment: '',
        approvalStatus: '',
        preferreduser:''
        
      },
      valid: true,
      request: '',
      search: ''
    }
  },
  mounted () {
    this.getUsers()
  },
  methods: {
    approveItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.request = 'Approve'
      this.editedItem.approvalStatus = 'approved'
    },
    declineItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.request = 'Decline'
      this.editedItem.approvalStatus = 'declined'
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.editedItem.approvalStatus === 'approved') {
          this.sendRequest('approve')
        } else if (this.editedItem.approvalStatus === 'declined') {
          this.sendRequest('decline')
        }
        this.close()
      }
    },
    sendRequest (request) {
      var url = config.serverURI + '/organization/user/' + request
      this.message = ''
      this.error = ''
      axios.post(url, this.editedItem)
        .then(response => {
          console.log('Update Response:', response)
          if (response.data.error) {
            this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
          } else {
            this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
          }
          this.users = this.getUsers()
          this.message = response.data.message
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
        })
    },
    getUsers () {
      var url = config.serverURI + '/organization/user/unapproved'
      axios.get(url)
        .then(response => {
          this.users = response.data
          console.log("Unapproved",response.data)
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
        })
      return this.users
    }
  }
}

</script>
<style>
</style>
